<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { currentPage } from '../stores/uiStore';
  import { t } from '../lib/i18n';
  
  const dispatch = createEventDispatcher();
  
  // Navigation items with translated labels
  $: navItems = [
    { id: 'dashboard', label: 'Панель управления', icon: 'bi-speedometer2' },
    { id: 'settings', label: 'Настройки', icon: 'bi-gear-fill' },
    { id: 'admin', label: 'Администрирование', icon: 'bi-shield-lock-fill' }
  ];
  
  function handleNavClick(pageId: string, params = {}) {
    currentPage.set(pageId);
    dispatch('navigate', { page: pageId, params });
  }
</script>

<nav class="navbar navbar-expand-lg navbar-light bg-white border-bottom shadow-sm sticky-top">
  <div class="container-fluid">
    <a class="navbar-brand d-flex align-items-center" href="#/" on:click|preventDefault={() => handleNavClick('dashboard')}>
      <i class="bi bi-bar-chart-line text-primary me-2" style="font-size: 1.5rem;"></i>
      <span class="fw-bold">ВременныеРяды<span class="text-primary">Анализатор</span></span>
    </a>
    
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Переключить навигацию">
      <span class="navbar-toggler-icon"></span>
    </button>
    
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        {#each navItems as item}
          <li class="nav-item">
            <a 
              class="nav-link {$currentPage === item.id ? 'active' : ''}" 
              href="#/{item.id}" 
              on:click|preventDefault={() => handleNavClick(item.id)}
              aria-current={$currentPage === item.id ? 'page' : undefined}
            >
              <i class="bi {item.icon} me-1"></i>
              {item.label}
            </a>
          </li>
        {/each}
      </ul>
      
      <div class="d-flex">
        <button 
          class="btn btn-outline-primary" 
          on:click={() => handleNavClick('dashboard', { action: 'create' })}
          aria-label="Создать новый временной ряд"
        >
          <i class="bi bi-plus-circle me-2"></i>
          Новый временной ряд
        </button>
      </div>
    </div>
  </div>
</nav>

<style>
  .navbar-brand {
    font-size: 1.25rem;
  }
  
  .nav-link {
    padding: 0.5rem 1rem;
    font-weight: 500;
    color: #212529;
    transition: color 0.2s ease-in-out;
  }
  
  .nav-link:hover {
    color: var(--primary-color);
  }
  
  .nav-link.active {
    color: var(--primary-color);
    border-bottom: 2px solid var(--primary-color);
  }
  
  @media (max-width: 768px) {
    .nav-link.active {
      border-bottom: none;
      background-color: #f0f8ff;
      border-radius: 4px;
    }
  }
</style>
